import React, { useState } from 'react'
import ReactSVG from 'react-svg'
import { propType } from 'graphql-anywhere'
import AccordionFields from '../../../graphql/fragments/accordion.gql'
import { sanitizeDom } from '../../utils'
import styles from './accordion-component.css'
import arrowDown from '../../../images/down-arrow.svg'
import arrowUp from '../../../images/up-arrow.svg'

const AccordionItem = ({ accordion }) => {
  const [isOpen, setIsOpen] = useState(false)
  const icon = isOpen ? arrowUp : arrowDown

  return (
    <div className={styles.accordionWrapper}>
      <div
        onClick={() => setIsOpen(!isOpen)}
        className={styles.accordionHeader}
      >
        <span>{accordion.header}</span>
        <ReactSVG
          src={icon}
          beforeInjection={svg => {
            svg.setAttribute('class', styles.accordionIcon)
          }}
        />
      </div>
      {isOpen && (
        <div
          className={styles.accordionContent}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: sanitizeDom(accordion.content) }}
        />
      )}
    </div>
  )
}

AccordionItem.propTypes = {
  accordion: propType(AccordionFields).isRequired
}

export default AccordionItem
